module.exports = __webpack_public_path__ + "images/f0470bebec2aab55dc36624d1bf6ee39.svg";